// extracted by mini-css-extract-plugin
export default {"produtos":"Inicio_produtos__l3zkC","buscar":"Inicio_buscar__RFMqV"};